/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

const smoothscroll = require('smoothscroll-polyfill');


exports.onClientEntry = () => {
    smoothscroll.polyfill();
  // Don't need to do anything here, but if you don't 
  // export something, the import won't work.
}